import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
`;

export const AdminLoginCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  box-shadow: ${(props: any) => props.theme.colors.boxShadow};
  padding: 40px;
  border-radius: 10px;
  width: 360px;
`;

export const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
  color: ${(props: any) => props.theme.colors.primary};
`;

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ErrorText = styled.div`
  color: red;
  font-size: 13px;
  margin-bottom: 10px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: ${(props: any) => props.theme.colors.white};
`;
export const Logo = styled.img``;

export const LoaderOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 16px;
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #ccc;
  border-top-color: #000;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin-bottom: 10px;
`;
